import api from "./Api";

class SessaoUsuarioService {
  GetSessaoUsuarioOData(payload) {
    return api.get("/OData/SessaoUsuario" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new SessaoUsuarioService();
